<ng-container *ngIf="data?.icon === 'info'">
  <p class="info" data-cy="toast-info">
    <mat-icon>info</mat-icon> <span data-cy="toast-message">{{ data?.message }}</span>
  </p>
</ng-container>

<ng-container *ngIf="data?.icon === 'warning'">
  <p class="warning" data-cy="toast-warning">
    <mat-icon>warning</mat-icon> <span data-cy="toast-message">{{ data?.message }}</span>
  </p>
</ng-container>

<ng-container *ngIf="data?.icon === 'success'">
  <p class="success" data-cy="toast-success">
    <mat-icon>check_circle</mat-icon> <span data-cy="toast-message">{{ data?.message }}</span>
  </p>
</ng-container>

<ng-container *ngIf="data?.icon === 'danger'">
  <p class="danger" data-cy="toast-danger">
    <mat-icon>error</mat-icon> <span data-cy="toast-message">{{ data?.message }}</span>
  </p>
</ng-container>
